import Header from "./header/Header"
import styles from "@styles/PageFrame.module.css"
import SideBar from "./SideBar"

import { ReactNode, useState } from "react"

export default function PageFrame({ children }: { children: ReactNode }) {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(false)

  return (
    <div className={styles.container}>
      <Header setSideBarCollapsed={setSideBarCollapsed} />
      <div className={styles.containerBody}>
        <SideBar collapsed={sideBarCollapsed} />
        <div className={styles.containerWorkingArea}>
          <div className={styles.workingArea}>
            <div className={styles.containerAppArea}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
